// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"8ec6b393","276":"12ffe84a","564":"2ea0eaf0","756":"ddea0f17"}[chunkId] + ".chunk.js";
};